import React from 'react';
import { Nav as ToolkitNav } from '@contently/toolkit';
import resolveSubdomains from './resolve_subdomains';

const BasicNav = ({ appData }) => {
  const { links, align } = JSON.parse(appData) || {};
  const parsedLinks = links
    ? links.map(link => ({...link, path: resolveSubdomains(null, link.path, false)}))
    : [];
  const linkData = {
    primaryLinks: [],
    secondaryLinks: parsedLinks,
    createLinks: [],
    userLinks: []
  };

  return (
    <ToolkitNav
      basic
      data={linkData}
      align={align}
      theme="v1"
    />
  )
}

export default BasicNav;



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/basic_nav.jsx